export function getTagColor(_text: string): string | undefined {
  return "grey";
}
